import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import Link from 'next/link';
import styles from './FooterNavigationMenu.module.scss';
import { flatListToHierarchical } from '@faustwp/core';
import React from 'react';

let cx = classNames.bind(styles);

export function FooterNavigationMenu({ menuItems, className }) {
	if (!menuItems) {
		return null;
	}

	// Based on https://www.wpgraphql.com/docs/menus/#hierarchical-data
	const hierarchicalMenuItems = flatListToHierarchical(menuItems);
	function renderMenu(items) {
		return (
			<ul className={cx('menu', 'menu__ul')}>
				{items.map((item) => {
					const { id, path, label, children, cssClasses, target, connectedNode } = item;
					const elem = connectedNode ? Link : 'a';

					// @TODO - Remove guard clause after ghost menu items are no longer appended to array.
					if (!item.hasOwnProperty('__typename')) {
						return null;
					}
					return (
						<li key={id} className={cx('menu__li')}>
							{path ? (
								React.createElement(
									elem,
									{
										href: path,
										className: cx(['menu__a']),
										target: target,
									},
									label ?? ''
								)
							) : (
								<h3 className={cx('parentCategory')}>{label ?? ''}</h3>
							)}
							{children.length ? renderMenu(children) : null}
						</li>
					);
				})}
			</ul>
		);
	}

	return (
		<nav className={cx(['ns_footer-nav', 'nav', className])} role="navigation" aria-label={`${menuItems[0]?.menu?.node?.name} menu`}>
			{renderMenu(hierarchicalMenuItems)}
		</nav>
	);
}

FooterNavigationMenu.fragments = {
	entry: gql`
		fragment FooterNavigationMenuItemFragment on MenuItem {
			id
			path
			label
			parentId
			cssClasses
			menu {
				node {
					name
				}
			}
			connectedNode {
				node {
					id
				}
			}
			target
		}
	`,
};
